import { useContext } from 'react';
import { useInterpret } from '@xstate/react';

import { DataAccessContext } from '@chargify/data-access';
import { changePlan } from '../machines';
import { GlobalStateContext } from '../contexts';

import { ProductChangeDoneEvent } from '../machines/changePlan/types';

export const useChangePlan = (
  catalogId: number,
  subscriptionId: number,
  currentPlanId: number,
  onSuccess: () => void,
  onThreeDsConfirmation: (threeDsActionLink: string) => void
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useContext(GlobalStateContext);
  return useInterpret(changePlan, {
    services: {
      getProducts: () => {
        return dataAccess.getProducts(catalogId);
      },
      previewProductMigration: ({ selectedPlan }) => {
        return dataAccess.previewProductMigration(subscriptionId, selectedPlan);
      },
      confirmProductMigration: ({ selectedPlan }) => {
        return dataAccess.migrateProduct(subscriptionId, selectedPlan);
      },
    },
    actions: {
      onSuccess,
      updateSubscription: (context, payload: ProductChangeDoneEvent) => {
        const { data: subscription } = payload;
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          catalogId,
          subscriptionId,
          ...subscription,
        });
      },
      onThreeDsConfirmation: (c) => onThreeDsConfirmation(c.threeDsActionLink),
    },
    context: {
      selectedPlan: currentPlanId,
    },
  });
};
